import React, { useEffect } from 'react';
import './Docs.css';

function Docs() {
  useEffect(() => {
    if (window.Prism) {
      window.Prism.highlightAll();
    }
  }, []);

  return (
    <section className="section docs-page-section">
      <div className="container is-max-desktop">
        <h1 className="title is-2">IPO-Mine Documentation</h1>
        <div className="content">
          <p className="is-size-5">
            Welcome to the IPO-Mine documentation. This guide provides information on how to use the toolkit and access the dataset.
          </p>
          
          <h2 className="title is-3 mt-6">Library Tour</h2>
          
          <h4 className="title is-5 mt-5">Setup</h4>
          <p>
            Install the IPO-Mine package via pip:
          </p>
          <pre><code className="language-bash">pip install ipo-mine</code></pre>

          <h4 className="title is-5 mt-5">Basic Usage</h4>
          <p>
            The example below shows how to initialize the downloader and retrieve a filing by company ticker:
          </p>
          <pre><code className="language-python">{`from ipo_mine import IPODownloader, Company

dl = IPODownloader("<email>", "<company>")
uber = Company.from_ticker("UBER")
filing = dl.download_ipo(uber)`}</code></pre>

          <p className="mt-5">
            Once downloaded, filings can be parsed by section name:
          </p>
          <pre><code className="language-python">{`from ipo_mine import IPOParser

parser = IPOParser(filing)
risk_factors = parser.parse_section("Risk Factors")`}</code></pre>

          <hr className="mt-6 mb-6" />
          
          <h2 className="title is-3">Advanced Features</h2>
          <p>
            The toolkit also supports high-resolution extraction of embedded figures and automated ingestion of S-1/A amendments. 
            Refer to our <a href="https://github.com/siddhxrth/IPO-Mine">GitHub repository</a> for the full API reference and advanced configuration options.
          </p>
        </div>
      </div>
    </section>
  );
}

export default Docs;
